module.exports = ["CB","VISA","MASTERCARD","AMEX","DINERS"]